export default __webpack_public_path__ + "static/media/enchiladas.5cabd2bb.jpeg";